import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Modal} from "../../../../../../../components/modal/modal.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../../components/button/button.jsx";
import {
    DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL_FLOATING_FILTERS
} from "../../../../../../../utils/ag-grid-columns-utils.js";
import userService from "../../../../../../../services/web/user-service.js";
import {useQuery} from "@tanstack/react-query";

const ModalAddUsers = ({show, setShow, responsible, setResponsible}) => {
    const [gridApi, setGridApi] = useState(null);
    const [usersList, setUsersList] = useState([])
    const addUserGridRef = useRef(null);

    useQuery({
        queryKey: ['responsible'],
        queryFn: async () => {
            return userService.optionsWithoutSystem().then(data => {
                setUsersList(data.filter(o => {
                    const find = responsible.find(g => g.id === o.id)
                    return !find;
                }))

                return []
            })
        },
        enabled: show
    });

    const columnDefsUsers = useMemo(() => [
        { headerName: "Nome", field: "name",
            flex: 1,
            comparator: aggridUtils.nullLastComparator,
            cellRenderer: params => {
                return (<span className={"cell-custom"}>{params.value}</span>)
            }
        },
        { headerName: "Nome de guerra", field: "namewar",
            flex: 1,
            comparator: aggridUtils.nullLastComparator,
            cellRenderer: params => {
                return (<span className={"cell-custom"}>{params.value}</span>)
            }
        },
    ], [])

    const add = () => {
        const newData = gridApi.getSelectedRows();

        setResponsible(prev => ([...prev, ...newData]))
        setShow(false)
    }

    return (
        <Modal open={show} setOpen={setShow} title="Adicionar almoxarife" className="w-6/12">
            <Modal.Body>
                <div className="h-[calc(100vh-350px)] aggrid-row-pointer">
                    <AgGridReact
                        onGridReady={(params) => {
                            setGridApi(params.api);
                        }}
                        ref={addUserGridRef}
                        rowData={usersList}
                        columnDefs={columnDefsUsers}
                        defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL_FLOATING_FILTERS}
                        rowSelection={{
                            mode: 'multiRow',
                            enableSelectionWithoutKeys: true,
                            enableClickSelection: true,
                            checkboxes: false,
                            headerCheckbox: false,
                        }}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={add}>Adicionar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAddUsers;